import api from './api';

// Kick off a long-running AI request as a background job and poll until it
// finishes. Resolves with the job's result; rejects with an axios-shaped
// error ({ response: { status, data: { detail } } }) so errMsg() formats it.
// Works around the ingress's hard ~60s request cap on multi-minute LLM runs.
export async function runAiJob(path, payload, { intervalMs = 2500, timeoutMs = 10 * 60 * 1000 } = {}) {
  const { data: started } = await api.post(path, { ...payload, async_job: true });
  const jobId = started?.job_id;
  if (!jobId) return started; // endpoint answered synchronously
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await new Promise(r => setTimeout(r, intervalMs));
    let job;
    try {
      ({ data: job } = await api.get(`/ai/jobs/${jobId}`));
    } catch (e) {
      if (e?.response?.status === 404) throw e;
      continue; // transient network blip — keep polling
    }
    if (job.status === 'done') return job.result;
    if (job.status === 'error') {
      const err = new Error('AI job failed');
      err.response = { status: job.error?.status || 500, data: { detail: job.error?.detail } };
      throw err;
    }
  }
  throw new Error('Mantle is taking longer than expected. Please try again.');
}
